// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-bar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background-color: gainsboro;
  gap: 1rem;
  padding: 1rem;
  min-height: 82px;
}`, "",{"version":3,"sources":["webpack://./src/components/HeaderBar/HeaderBar.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,2BAAA;EACA,SAAA;EACA,aAAA;EACA,gBAAA;AACF","sourcesContent":[".header-bar {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  background-color: gainsboro;\n  gap: 1rem;\n  padding: 1rem;\n  min-height: 82px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
